<template>
  <div class="grid grid-cols-1 mt-0 lg:grid-cols-2 gap-6 w-full">
    <div class="bg-white border border-gray-100 rounded-2xl p-6 shadow-sm flex flex-col justify-start relative ">
      <div>
        <h2 class="text-xl font-bold text-gray-900 mb-6">Awareness</h2>
        <div v-if="!isAwarenessEmpty" class="grid grid-cols-3 gap-4 mb-0">
          <div v-for="(metric, idx) in awarenessMetrics" :key="idx">
            <div class="text-gray-400 mb-1">

              <svg v-if="metric.type === 'install'" class="w-7 h-7 text-gray-500 dark:text-white" aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                <path fill-rule="evenodd"
                  d="M13 11.15V4a1 1 0 1 0-2 0v7.15L8.78 8.374a1 1 0 1 0-1.56 1.25l4 5a1 1 0 0 0 1.56 0l4-5a1 1 0 1 0-1.56-1.25L13 11.15Z"
                  clip-rule="evenodd" />
                <path fill-rule="evenodd"
                  d="M9.657 15.874 7.358 13H5a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-2.358l-2.3 2.874a3 3 0 0 1-4.685 0ZM17 16a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H17Z"
                  clip-rule="evenodd" />
              </svg>
              <svg v-else-if="metric.type === 'apps'" class="w-7 h-7 text-gray-500 dark:text-white" aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                <path fill-rule="evenodd"
                  d="M7.5 4.586A2 2 0 0 1 8.914 4h6.172a2 2 0 0 1 1.414.586L17.914 6H19a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h1.086L7.5 4.586ZM10 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm2-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z"
                  clip-rule="evenodd" />
              </svg>
              <svg v-else-if="metric.type === 'onsite'" class="w-7 h-7 text-gray-500 dark:text-white" aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                <path fill-rule="evenodd"
                  d="M5 4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4Zm12 12V5H7v11h10Zm-5 1a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H12Z"
                  clip-rule="evenodd" />
              </svg>
            </div>
            <p class="text-base text-gray-500 font-medium">{{ metric.label }}</p>
            <h3 class="text-2xl font-bold text-gray-900">{{ metric.value }}</h3>
          </div>
        </div>
      </div>
      <div class="w-full">
       <div 
        v-if="isLoadingSummary" 
        class="absolute h-full bg-white inset-0 bg-white/70 z-10 flex items-center justify-center rounded-xl"
      >
            <div class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col items-center">
        <svg class="h-26 w-16 animate-spin text-blue-600 mb-4" xmlns="http://www.w3.org/2000/svg" fill="none"
          viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"></circle>
          <path d="M12 2 A 10 10 0 0 1 22 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"></path>
        </svg>
      </div>
      </div>
        <div v-if="isAwarenessEmpty"
          class="flex h-36 justify-center w-full flex-col items-center space-y-2 rounded-xl">
          <div>
<img src="../../assets/img/empty_smartpin.png" class=" w-12" alt="" /> 
          </div>
          <p class="text-sm text-center font-medium text-gray-800">No Data Yet</p>
           
        </div>
        <div class="w-full">
          <apexchart v-show="!isAwarenessEmpty" type="bar" height="120" :options="awarenessChartOptions"
            :series="awarenessSeries" class="w-full" />
        </div>

      </div>
    </div>

    <div class="bg-white border border-gray-100 rounded-2xl p-6 shadow-sm relative flex flex-col justify-start">
      <h2 class="text-xl font-bold text-gray-900 mb-3">Acquisition</h2>
  <div 
        v-if="isLoadingFunnel" 
        class="absolute h-full bg-white inset-0 bg-white/70 z-10 flex items-center justify-center rounded-xl"
      >
            <div class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col items-center">
        <svg class="h-26 w-16 animate-spin text-blue-600 mb-4" xmlns="http://www.w3.org/2000/svg" fill="none"
          viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"></circle>
          <path d="M12 2 A 10 10 0 0 1 22 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"></path>
        </svg>
      </div>
      </div>
      <div class="relative w-full h-[240px] flex items-center justify-center">
          <div v-if="isAcquisitionEmpty"
          class="flex h-36 justify-center w-full flex-col items-center space-y-2 rounded-xl">
          <div>
<img src="../../assets/img/empty_smartpin.png" class=" w-12" alt="" /> 
          </div>
          <p class="text-sm text-center font-medium text-gray-800">No Data Yet</p>
           
        </div>
        <apexchart v-show="!isAcquisitionEmpty" type="bar" height="240" :options="funnelChartOptions"
          :series="funnelSeries" class="w-full" />
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'SummaryInsightCharts',
  props: {
    isLoadingFunnel: {
      type: Boolean,
      default: false
    },
    isLoadingSummary: {
      type: Boolean,
      default: false
    },
    awarenessMetrics: {
      type: Array,
      default: () => []
    },
    awarenessSeries: {
      type: Array,
      required: true
    },
    awarenessChartOptions: {
      type: Object,
      required: true
    },
    funnelSeries: {
      type: Array,
      required: true
    },
    funnelChartOptions: {
      type: Object,
      required: true
    },
    rawAcquisitionValues: {
      type: Array,
      default: () => [0, 0, 0]
    }
  },
  computed: {
    isAwarenessEmpty() {
      if (!this.awarenessMetrics || this.awarenessMetrics.length === 0) return true;
      return this.awarenessMetrics.every(metric => Number(metric.value) === 0);
    },
    isAcquisitionEmpty() {
      if (!this.rawAcquisitionValues || this.rawAcquisitionValues.length === 0) return true;
      return this.rawAcquisitionValues.every(val => Number(val) === 0);
    }
  }
};
</script>
